export default __webpack_public_path__ + "static/media/yooz-secure.72523788.png";